import mergeWith from "lodash/mergeWith";
const concatArrays = (objValue, srcValue) => Array.isArray(objValue) ? objValue.concat(srcValue) : void 0;
const mergePluginBindings = (...bindings) => mergeWith({}, ...bindings, concatArrays);
export default mergePluginBindings;
